"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateContactDto = void 0;
class CreateContactDto {
    title;
    phone;
    name;
    email;
    message;
    company;
    report;
}
exports.CreateContactDto = CreateContactDto;
